export const POSTPONED_PAYMENT_METHOD = {
	BANK_DIRECT: 1,
	BANK_TRANSFER: 2,
	CONFIRMING: 3,
	BANK_NOTE: 4,
}
